import React, { useState } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import Navigation from "./Navigation";
import MobileAppBar from "./MobileAppBar";

const drawerWidth = 240;

export default function Layout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {isMobile && <MobileAppBar onMenuClick={handleDrawerToggle} />}

      <Navigation
        mobileOpen={mobileOpen}
        onDrawerToggle={handleDrawerToggle}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, sm: 2, md: 3 },
          ml: { xs: 0, md: `${drawerWidth}px` },
          mt: { xs: '64px', md: 0 },
          backgroundColor: '#1e1e1e',
          minHeight: '100vh'
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
